import styled from "styled-components";
import { primaryColor } from "../../../../config";

export const Wrapper = styled.div`
  color: var(--app-text);

  .adv-settings-page-title {
    color: var(--app-text) !important;
    margin-top: 8px;
    font-size: 22px;
  }

  .adv-settings-page-desc.ant-typography {
    color: var(--app-text-muted) !important;
  }

  .adv-settings-page .ant-card {
    background: var(--app-surface) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text);
  }

  .adv-settings-page .ant-divider {
    border-color: var(--app-border) !important;
  }

  .adv-settings-section-title {
    color: var(--app-text) !important;
  }

  .adv-settings-section-subtitle {
    color: var(--app-text-muted) !important;
  }

  .adv-settings-page .ant-typography {
    color: var(--app-text);
  }

  .adv-settings-page .ant-typography.ant-typography-secondary {
    color: var(--app-text-muted) !important;
  }

  .adv-settings-toggle-yes {
    margin-left: 8px;
    color: ${primaryColor};
  }

  .adv-settings-toggle-no {
    margin-left: 8px;
    color: var(--app-text-muted);
  }

  .adv-settings-seller-flex-panel {
    margin-top: 16px;
    padding: 16px;
    background-color: var(--app-surface-alt);
    border-radius: 8px;
    border: 1px solid var(--app-border);
  }

  .adv-settings-seller-flex-label {
    display: block;
    margin-bottom: 10px;
    font-size: 12px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--app-text-muted);
  }

  .adv-settings-seller-flex-hint .anticon {
    color: var(--app-text-muted);
  }

  .adv-settings-page a {
    color: ${primaryColor};
  }

  .adv-settings-page a:hover {
    color: #cd404c;
  }

  .adv-settings-page .ant-select-selector {
    background: var(--app-surface) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
  }

  .adv-settings-page .ant-select-selection-placeholder {
    color: var(--app-text-muted) !important;
  }

  .adv-settings-page .ant-select-selection-item,
  .adv-settings-page .ant-select-selection-item-content {
    color: var(--app-text) !important;
  }

  .adv-settings-page .ant-select-multiple .ant-select-selection-item {
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  [data-bs-theme="dark"] & .adv-settings-page .ant-select-multiple .ant-select-selection-item {
    background: #2b2b40 !important;
    border-color: #3f4254 !important;
  }

  [data-bs-theme="dark"] & .symbol-label.bg-light-danger {
    background-color: rgba(244, 91, 104, 0.15) !important;
  }

  [data-bs-theme="dark"] & .adv-settings-page .ant-btn-default:not(:disabled) {
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
  }

  [data-bs-theme="dark"] & .adv-settings-page .ant-btn-default:hover:not(:disabled) {
    background: #2b2b40 !important;
    border-color: var(--app-border) !important;
    color: var(--app-text) !important;
  }

  .ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-item-content {
    font-size: 14px;
  }
`;
